import { Box, Card, useMediaQuery, useTheme } from "@mui/material";
import React, { ReactNode } from "react";
import { EnumHelper, FrontPagePanelSize } from "ui/Scripts/source/models/enums";

interface PanelContainerProps {
  size: number;
  children: ReactNode;
}

const getPanelWidth = (panelSize: number): string => {
    return EnumHelper.isEqual(panelSize, FrontPagePanelSize.TwoXOne) || EnumHelper.isEqual(panelSize, FrontPagePanelSize.TwoXTwo)
        ? "66.666667%"
        : (EnumHelper.isEqual(panelSize, FrontPagePanelSize.ThreeXOne) || EnumHelper.isEqual(panelSize, FrontPagePanelSize.ThreeXTwo))
            ? "100%"
            : "33.333334%";
};

const getPanelHeight = (panelSize: number): string => {
    return EnumHelper.isEqual(panelSize, FrontPagePanelSize.OneXTwo) || EnumHelper.isEqual(panelSize, FrontPagePanelSize.TwoXTwo) || EnumHelper.isEqual(panelSize, FrontPagePanelSize.ThreeXTwo)
        ? "calc(100vh - 174px)"
        : "calc(50vh - 87px)";
};

export const PanelContainer = ({
    size,
    children,
}: PanelContainerProps) => {
    const theme = useTheme();
    const largeScreen = useMediaQuery(theme.breakpoints.up("lg"));

    return (
        <Box
            sx={{
                width: largeScreen ? getPanelWidth(size) : "100%",
                height: getPanelHeight(size),
                minHeight: "300px",
                padding: "8px 8px 5px",
                float: "left",
            }}
        >
            <Card elevation={3} sx={{ height: "100%", padding: "1rem 0" }}>
                {children}
            </Card>
        </Box>
    );
};
